<app-navbar (toggleSidebarEvent)="toggleSidebar()"></app-navbar>

<mat-sidenav-container autosize>
  <mat-sidenav #sidenav mode="side" [opened]="isSidebarOpen$()" [ngStyle]="{ width: isSidebarOpen$() ? '250px' : '0px' }"
    [mode]="isMobile$() ? 'over' : 'side'">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="p-4">
    <xng-breadcrumb separator=">">
      <ng-container *xngBreadcrumbItem="let breadcrumb">
        <ng-container>{{ breadcrumb | titlecase }}</ng-container>
      </ng-container>
    </xng-breadcrumb>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-footer></app-footer>